
import React, { useState, useEffect } from 'react';

import { GetArrival } from './GetArrival.js';


/**
 * хук возвращающий прилёты в указаный город
 */
export const useArrival = cityCode => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        GetArrival(cityCode).then(data => {
            setData(data);
            setLoading(false);
        });
    }, []);

    return [data, loading];
}